var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 44,
    viewBox: "0 0 15 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 9.08342L1.16699 7.10425C1.16699 3.82506 3.96521 1.16675 7.41699 1.16675C10.8688 1.16675 13.667 3.82506 13.667 7.10425L13.667 9.08342M1.16699 9.08342C1.16699 9.08342 3.51074 11.0626 7.41699 11.0626C11.3232 11.0626 13.667 9.08342 13.667 9.08342M1.16699 9.08342L1.16699 29.3622C1.16699 30.5946 1.16699 31.2108 1.24567 31.8155C1.33848 32.5288 1.51282 33.2304 1.7656 33.9078C1.97988 34.4821 2.26996 35.0332 2.85013 36.1355L5.30854 40.8065M13.667 9.08342L13.667 29.3622C13.667 30.5946 13.667 31.2108 13.5883 31.8155C13.4955 32.5288 13.3212 33.2304 13.0684 33.9078C12.8541 34.4821 12.564 35.0332 11.9839 36.1355L9.52545 40.8065M9.52545 40.8065L8.92451 41.9483C8.639 42.4908 8.05539 42.8334 7.41699 42.8334C6.77859 42.8334 6.19498 42.4908 5.90948 41.9483L5.30854 40.8065M9.52545 40.8065H5.30854",
    stroke: "url(#paint0_linear_3918_144)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3918_144",
    x1: 13.667,
    y1: 22.0001,
    x2: 1.16699,
    y2: 22.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.f6a2f41c82a3d999f7b10698011e80b1.svg";
export { ForwardRef as ReactComponent };